<template>
  <div id="slate-int-default-container">
    <slot>Default interactive text</slot>
  </div>
</template>

<script>
export default {
  name: 'defaultContainer'
}
</script>

<style>
#slate-int-default-container {
  position: relative;
  box-sizing: border-box;
  border: 1px solid #c7c7c7;
  width: 100%;
  height: 100%;
  padding: 5%;
  background: white;
}
</style>



// WEBPACK FOOTER //
// DefaultContainer.vue?00a72a2e